@if (showPopup) {
  <div class="popup-box">
    <div class="in-box">
      <button type="button" class="leave-button" (click)="showPopup = false"></button>
      <img class="gallery_popup_img" [src]="galleryImage">
      <div class="download-button" (click)="downloadImage(galleryImage)"></div>
    </div>
  </div>
}

<div class="frame-in">
  <div [ngClass]="{'hidden': loading}">
    <div class="gallery">
      <button type="button" class="leave-button" (click)="previousState()"></button>

      <button type="button" class="slider-back" (click)="previous()"></button>
      <button type="button" class="slider-next" (click)="next()"></button>
      <div>
        @for (tab of tabs; track $index; let i = $index) {
          @if (activeWindow == i+1) {
            <div class="blocks-list">
              @for (item of tab; track $index) {
                @if (item.imageUrl | downloadUrl | async; as photoUrl) {
                  <div class="gallery-item"
                    (click)="openPopup(item, $any(photoUrl))">
                    <img [src]="photoUrl">
                    <div class="description-box">
                      {{item.countryTitle}}
                    </div>
                    <div class="letter"><span [ngClass]="{'letter-arabic-medium': isMedium(item.arabicLetter), 'letter-arabic-high': isHigh(item.arabicLetter)}">{{item.arabicLetter}}</span></div>
                  </div>
                }
              }
            </div>
          }
        }
      </div>
      <div class="tab-bar">
        @for (tab of tabs; track $index; let i = $index) {
          <div class="tab" [ngClass]="{'active': activeWindow == i+1}" (click)="activeWindow = i+1">
          </div>
        }
      </div>
    </div>
    <img class="frame-bg" src="assets/images/gallery/bg.jpg" (loadeddata)="instructionLoaded()">
  </div>
</div>
